import React from 'react';
import { connect } from 'react-redux';
import Resizer from './Resizer.jsx';
import SmallCardFramework from './SmallCardFramework.jsx';
import LargeCardFramework from './LargeCardFramework.jsx';


class MediaLabCardFramework extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'MediaLabCardFramework';

    // bind functions to component
    this.renderContent = this.renderContent.bind(this);
  }


  /**
   * Renders content
   * @returns {ReactElement} - The small or large card framework, depending on
   * the user's screen size
   */
  renderContent() {
    let element;
    const state = this.props.mediaLabCardFrameworkState;
    const windowSize = state.windowSize;
    const smallData = [];
    const largeData = [];

    for (let i = 0; i < this.props.data.length; i++) {
      if (!this.props.data[i].skipOnMobile) {
        smallData.push(this.props.data[i]);
      }
    }

    for (let i = 0; i < this.props.data.length; i++) {
      if (!this.props.data[i].skipOnDesktop) {
        largeData.push(this.props.data[i]);
      }
    }

    if (windowSize.width < this.props.largeBreakpoint) {
      element = (
        <SmallCardFramework
          data={smallData}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    } else {
      element = (
        <LargeCardFramework
          data={largeData}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const content = this.renderContent();
    const className = 'card component-media-lab-card-framework';

    return (
      <div className={className}>
        {content}
        <Resizer />
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Array<Object>} data - An array of json objects
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Number} largeBreakpoint - A width breakpoint
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * MediaLabCardFramework component
 */
MediaLabCardFramework.propTypes = {
  data: React.PropTypes.array.isRequired,
  dispatch: React.PropTypes.func,
  largeBreakpoint: React.PropTypes.number,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
};


export default connect(({ mediaLabCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState }))(MediaLabCardFramework);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/MediaLabCardFramework.jsx
 **/